import {track} from "@amplitude/analytics-browser";
import {faTicket} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, MantineSize} from "@mantine/core";
import Link from "next/link";

import type {Unit} from "../../graphql/types";

export interface ReserveUnitButtonProps {
  unit: Partial<Unit>; // Unit the reserve button is for
  title?: string | null; // Custom title for the button
  source?: string; // Analytics tracking source (where is this button being displayed?)
  variant?: string; // Button variant
  size?: MantineSize; // Button size
}

/**
 * "Reserve unit" button
 *
 * Navigates to the agency-specific registration page
 */
export default function ReserveUnitButton({
  unit,
  title,
  source,
  variant = "primary",
  size = "lg",
}: ReserveUnitButtonProps) {
  if (title === undefined) {
    title = "Reserve";
  }

  return (
    <Button
      variant={variant}
      className="reserve-unit-button"
      size={size}
      disabled={!unit.bookingUrl}
      component={Link}
      href={unit.bookingUrl || "#"}
      target="_blank"
      onClick={event => {
        track("Reserve Unit Button Clicked", {
          unit: {
            id: unit.id,
            name: unit.name,
          },
          source,
        });

        if (!unit.bookingUrl) {
          // Stop link click event
          event.preventDefault();
        }
      }}
      leftSection={<FontAwesomeIcon icon={faTicket} />}>
      {title}
    </Button>
  );
}
